const properties = {
    buildId: '202610.0',
    contextPath: 'https://rckms-test.sandbox2.aimsplatform.org',
    rsBaseServiceUri: 'https://rckms-mts-test.authoring.sandbox2.aimsplatform.org',
    rsCrudContextPath: '/mts-rs-{0}',
    reportsServiceEndpoint: 'https://rckms-rrs-test.authoring.sandbox2.aimsplatform.org',
};

export default properties;
